<template>
  <v-container :class="isSPSize ? 'sp' : ''">
    <v-row>
      <v-col cols="12">
        <h1 :class="h1Style" class="title-border">
          Privacy Policy
        </h1>
      </v-col>
      <v-col cols="12">
        <p>
          Attic Start Co., Ltd. (the &quot;Company&quot;) sets forth the Privacy Policy (the &quot;Policy&quot;) with regard to the treatment of user information(Article 2, Paragraph 1 of the Act on the Protection of Personal Information), including but not limited to personal information, in the course of the performance of Service provided by the Company (the “Service&quot;),as follows;<br>
          Please read the Policy before using the Services. In order to use the Services, the User must agree to the terms of the Policy; otherwise, the User may not use the Services. Please refer to the Terms for definitions of terms in the Policy.
        </p>
        <p>
          1 User information to be collected and the method of collection
        </p>
        <p>
          “User Information” in the Policy means information related to customer identification, a customer’s action history on communication services, and other information related to customers or the Users terminals generated or stored on customer’s smartphones, personal computers, or other terminals that the Company collects pursuant to the Policy. User information that The Company collects in the Services, depending on the method of collection, shall be as follows.
        </p>
        <p class="mb-2">
          (1) Information provided by the user
        </p>
        <p>In order to use the Services, the User will provide us with the following information.</p>
        <ul class="mb-3">
          <li>Name, country of origin, a region of residence, telephone number, e-mail address, date of birth, sex, photo</li>
          <li>Place of departure, destination, duration of the trip and area of availability</li>
          <li>Interest/the thing what the User like, language, language level, self-introduction</li>
          <li>Feedback, comments, and reviews relevant to the use of the Services;</li>
          <li>Other information the Users enter in registration forms provided by The Company</li>
        </ul>
        <p class="mb-2">
          (2) Information that, when a customer permits linkage with other services in using the Services, is provided by such other services
        </p>
        <p>
          If when using the Services, a customer permits linkage with social network services and other external services, the Company may collect information provided by external services with which linkage has been permitted. Such information includes the following:
        </p>
        <ul class="mb-3">
          <li>IDs and other identification information that a customer uses on such external services</li>
          <li>Other information that a customer permits on the privacy settings of such external services disclosure to linkage partners</li>
        </ul>
        <p class="mb-2">
          (3) Information automatically collected by the Company in the course of the user's use of the Service
        </p>
        <p>
          The Company may collect information regarding access to or use of the Service, which includes the following.
        </p>
        <ul class="mb-3">
          <li>Device information</li>
          <li>Information regarding server access logs</li>
          <li>Identifying information generated using cookie technology</li>
          <li>Location information</li>
          <li>IP address</li>
          <li>Chat with other Users</li>
        </ul>
        <p>
          2 Purpose of Use
        </p>
        <p>
          Collected usage information is used for the following purposes.
        </p>
        <p class="mb-2">
          (1) Provision, improvement and development of the Services
        </p>
        <ul class="mb-3">
          <li>To provide the Services, register for use, and confirm the identity</li>
          <li>To be used for matching with other users (the Traveler or the Local)</li>
          <li>To maintain, protect and maintain the Services and improve the quality of the Services</li>
          <li>To provide the Services safely (finding users who violate the Terms of Service and notifying them, and investigating, detecting and preventing misconduct such as misuse, fraud and unauthorized access of the Services)</li>
          <li>To develop new services and functions</li>
          <li>To maintain the system and respond to problems</li>
          <li>To conduct a questionnaire</li>
          <li>To respond to guidance, inquiries, etc. concerning the Services;</li>
          <li>To notify customers of information on promotions, after-sale services, and new products and services relating to the Services;</li>
          <li>To distribute information (including advertisements, etc.) regarding third parties related to the Service</li>
          <li>To notify the User of changes in the terms of the Services, etc.</li>
          <li>To discover, prevent, and respond to fraud, abuse, abuse, spam, and other harmful acts or acts that violate the Terms of Service</li>
          <li>Any other purposes incidental to the above-mentioned purposes of use; or</li>
        </ul>
        <p class="mb-2">
          (2) Develop services based on advertising, marketing and data analysis
        </p>
        <p>
          The Company may use and analyze the collected information to create statistical data processed in a format that cannot identify individuals for marketing, consulting, advertisement display, advertisement distribution, etc. Information that is processed and used in a format that cannot identify individuals is as follows.
        </p>
        <ul class="mb-3">
          <li>Device information</li>
          <li>Information regarding server access logs</li>
          <li>Identifying information generated using cookie technology</li>
          <li>Location information</li>
          <li>IP Address</li>
          <li>Language of Use.</li>
          <li>National origin</li>
          <li>Residential area</li>
          <li>Age, Date of Birth</li>
          <li>Gender</li>
          <li>Chat with other Users</li>
          <li>Feedback, Feedback, and Reviews</li>
          <li>Other information the User registers in The Company’s registration form, inquiry form or other forms.</li>
        </ul>
        <p>
          3.Method of requesting discontinuation of use
        </p>
        <p>
          By performing the prescribed settings for the Services, the User may request discontinuation of use of all or part of his/her User Information; in such a case, in accordance with the Company’s stipulations, the Company will promptly discontinue such use. Depending on the type of User Information, the collection or use of such information may be a condition to the Services, and in such a case, if and only if the User cancels the Services in a manner prescribed by the Company, the Company will discontinue such collection.
        </p>
        <p>
          4.Consent to the provision of User Information to third parties
        </p>
        <p>
          Before using the Services, a customer must consent to the provision of User Information by the Company to third parties as set forth below. User &#39;s ID, nickname, photograph, sex, age-based generation, place of travel, a region of residence, country of origin, a region of activity, interest, the things the User likes, language used, language learning level, self-introduction, past usage history of the Services, and any other information permitted by the User;
        </p>
        <p>
          5 Provision of personal information to third parties
        </p>
        <p>
          Without obtaining prior consent under the preceding paragraph, unless permitted under the Personal Information Protection Act or other laws and regulations, the Company will not provide any User Information that is personal information to third parties without obtaining the prior consent of the User; provided, however, that the following will not apply in the following cases:
        </p>
        <p class="mb-2">
          (1) If the Company the outsources the handling of personal information in whole or in part within the scope necessary to realize the use purposes;<br>
          (2) If personal information is provided in conjunction with a merger or other business succession;<br>
          (3)If, in a case where it is necessary to cooperate with a government agency, local public agency, or a person entrusted by either of the foregoing in the carrying out of work stipulated under laws and regulations, the act of obtaining the consent of the User is likely to hinder such work; or<br>
          (4) If otherwise permitted under the Personal Information Protection Act or other laws and regulations<br>
        </p>
        <p>
          6.Safety management for protection of personal information
        </p>
        <p>
          The Company will stipulate rules to protect the personal information it acquires, publicize and emphasize such rules to its employees, and work towards maintaining and enhancing safety management measures necessary to protect the personal information acquired by the Company.
        </p>
        <p>
          7.Disclosure of personal information
        </p>
        <p>
          If a customer requests disclosure of personal information pursuant to the stipulations of the Personal Information Protection Act, after confirming that such request is from the User himself/herself or a legitimate agent (presentation of personal identification documents may be requested), the Company will make the disclosure to the User without delay (if the relevant personal information does not exist, the User will be notified to that effect); provided, however, that the foregoing will not apply in cases where the Company is not obligated to make disclosure under the Personal Information Protection Act or other laws and regulations. It should be noted in advance that there will be a fee (500 yen per request) for the disclosure of personal information.
        </p>
        <p>
          8.Correcting and discontinuing use etc. of personal information
        </p>
        <p class="mb-2">
          (1) Correction and suspension of the use of personal information
        </p>
        <p>
          If (i) on the grounds that personal information is not true, a customer requests the correction of the content of such information pursuant to the Personal Information Protection Act, or (ii) on the grounds that personal information is being handled beyond the scope of use purposes announced in advance or that personal information was obtained through deceit or other unauthorized means, a customer requests discontinuation of use of personal information pursuant to the Personal Information Protection Act, or (ⅲ) on the grounds that personal information is provided to third parties in contravention of Restriction on Third Party Provision of the Personal Information Protection Act, a customer requests discontinuation of the provision to third parties, after confirming that the request is from the User himself/herself, the Company will perform the necessary investigation without delay, and on the basis of the findings of such investigation, correct the content of, discontinue the use of personal information or discontinue the provision to third parties, and notify the User to that effect. If the Company decides not to correct, discontinue use or discontinue the provision to third parties based on a valid reason, the User will be notified to that effect.
        </p>
        <p class="mb-2">
          (2) Deletion of personal information
        </p>
        <p>
          If a customer requests removal of his/her personal information, and the Company determines that it is necessary to comply with such request, after confirming that the request is from the User himself/herself, the Company will remove the personal information, and notify the User to that effect.
        </p>
        <p class="mb-2">
          (3) Exemption
        </p>
        <p>
          TIf under the Personal Information Protection Act or other laws and regulations, the Company is not obligated to carry out correction etc. or discontinuation of use etc., the preceding two paragraphs will not apply.
        </p>
        <p>
          9.Contact point for inquiries
        </p>
        <p>
          Opinions, questions, complaints, and other inquiries concerning the handling of User Information should be addressed to the following:
        </p>
        <p>
          2-5 -3 Nagatachi GRID 5F Midori.so, Hirakawa-cho, Chiyoda-ku, Tokyo 〒102-0093<br />
          Attic Start Customer Support Center (Manager: Keisuke Tomida)<br />
          E-mail：<a href="mailto:support@paikeout.com">support@paikeout.com</a>
        </p>
        <p>
          10.Procedures to amend the Policy
        </p>
        <p>
          The Company will perform appropriate reviews of the state of operations relating to the handling of User Information, work towards continuous improvement, and may amend the Policy when necessary. If the Policy is amended, customers will be notified by posting on the Company’s webpage; provided, however, that for amendments that require the consent of customers under laws and regulations, the consent of customers will be obtained by methods prescribed by the Company.
        </p>
        <p class="text-right">End</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn
          rounded
          large
          dark
          align-items="center"
          color="gray"
          width="250"
          class="font-weight-bold text-capitalize"
          @click="existsHistory ? $router.go(-1) : $router.push('/en')"
        >
          {{ existsHistory ? 'Back' : 'Top' }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  computed: {
    h1Style() {
      return this.isSPSize
        ? 'font-h1-sp font-weight-bold mb-3'
        : 'font-h1-pc font-weight-bold mb-5'
    },
    isSPSize() {
      return this.$vuetify.breakpoint.name === 'xs'
    },
  },
  data: () => ({
    existsHistory: false,
  }),
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.existsHistory = from.name != null
    })
  },
}
</script>

<style lang="stylus" scoped>
p
  line-height 1.5
  font-size 15px

.sp
  p, ul, ol
    font-size 12px
</style>